import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSearchVoided = () => {
  return useMutation(getInvoiceBy);
};
export default useSearchVoided;
